<div class="container-fluid bg-image vh-100">
  <div class="row px-4">
    <div class="col-2">
      <img class="logo1" src="assets/images/login/NewLogo.png" /><br />
      <img class="logo" src="assets/images/login/logo_2.png" />
    </div>
    <div class="col-8">
    </div>
    <div class="col-2 democlass">
      <div class="button">
        <button type="button" class="btn btn-outline-primary" (click)="demoVideo()">
          Demo Video
        </button>
        <!-- <a href="assets/images/login/manual.pdf" target="_blank" class="btn_psn">
          <button type="button" class="btn btn-outline-primary">Step-by-step Guide</button></a> -->
      </div>
    </div>
  </div>
  <div class="row floor_design">
    <div class="col-md-12 d-flex justify-content-end">
      <form [formGroup]="loginForm" class="h-100">
        <div class="d-flex gap-2 align-items-center h-100">
          <div class="form-group">
            <label for="exampleInputEmail1">User ID <span class="required">*</span></label>
            <input type="email" class="form-control" id="exampleInputEmail1" formControlName="email"
              aria-describedby="emailHelp" placeholder="Enter User ID" />
            <div class="form-error">
              <div
                *ngIf="loginForm.controls['email'].errors && (!loginForm.controls['email'].pristine || isFormSubmitted)">
                <div [hidden]="!loginForm.controls['email'].errors['required']"> Please Enter User ID</div>
              </div>
            </div>
          </div>
          <div class="form-group password">
            <label for="exampleInputPassword1">Password <span class="required">*</span></label>
            <input type="password" class="form-control" id="exampleInputPassword1" formControlName="password"
              placeholder="Password" />
            <div class="form-error">
              <div
                *ngIf="loginForm.controls['password'].errors && (!loginForm.controls['password'].pristine || isFormSubmitted)">
                <div [hidden]="!loginForm.controls['password'].errors['required']">Please Enter Password</div>
              </div>
            </div>
            <div class="button">
              <button type="button" class="btn btn-link px-0" routerLink="/auth/forgot-password" (click)="saveRole()"
                style="margin-left: 25px; color: white;">Forgot Password?</button>
            </div>
          </div>

          <div class="mt-8">
            <button type="submit" class="btn btn-primary"
              style="margin-top: 12px; width: 80px; height: 30px; padding: 3px; font: size 10px;" (click)="login()">
              Login
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>